module.exports = __webpack_public_path__ + "media/video807.248edef5.mp4";